import { PropsWithChildren } from 'react'
import { usePage } from '@inertiajs/react'
import { Toaster } from '@/components/ui/sonner'
import { ThemeProvider } from '@/components/ThemeProvider'

interface User {
  id: number
  name?: string
  email: string
  role: string
  verified: boolean
  /** Módulos que este usuário alcança, já resolvidos pelo servidor: dono e acesso
   *  total chegam com a lista completa, para o front não reimplementar a regra e
   *  errar diferente do backend. */
  permissions?: string[]
  panel_access?: boolean
  full_access?: boolean
  commission_enabled?: boolean
  school?: {
    id: number
    name: string
    description: string
    avatar_url?: string | null
    primary_color?: string
    secondary_color?: string
    theme_mode?: 'light' | 'dark'
    enrollments_enabled?: boolean
  }
}

interface SharedProps {
  auth: {
    user: User | null
  }
  flash: {
    notice?: string
    alert?: string
  }
  [key: string]: any
}

export function useAuth() {
  const { auth } = usePage<SharedProps>().props
  return auth || { user: null }
}

export function useFlash() {
  const { flash } = usePage<SharedProps>().props
  return flash || {}
}

export default function Layout({ children }: PropsWithChildren) {
  return (
    <ThemeProvider>
      {children}
      <Toaster />
    </ThemeProvider>
  )
}
